// extracted by mini-css-extract-plugin
export default {"requirementContainer":"RequirementBox_requirementContainer__BVa-G"};